import { useEffect, useState } from "react";
import { Button } from '../../components/button'
import { DashboardWrapper } from "../../container/dashboardWrapper"
import { StyledContainer, StyledContent, StyledMainContentWrapper, StyledTopWrapper, StyledNextPageDiv, StyledNextPageDivContainer } from "../../styles/examination"

import {
    MdAssessment,
    MdHelpOutline,
    MdTimer
} from "react-icons/md";
import { QuestionsStepper } from '../../components/questions-stepper'
import { examQuestions } from '../../services/examData'
import { Link } from 'react-router-dom';
import { Breadcrumb } from '../../components/breadcrumb/breadcrumb';

const ExamQuestions = () => {
    const [paginatedResults, setPaginatedResults] = useState([])
    const [currentPage, setCurrentPage] = useState(1)

    function paginate(array, page_size, page_number) {
        // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
        return array.slice((page_number - 1) * page_size, page_number * page_size);
    }

    const handleNextPage = () => {
        const newPaginatedResult = paginate(examQuestions, 4, currentPage + 1)
        setCurrentPage(currentPage + 1)
        setPaginatedResults(newPaginatedResult)
        console.log(newPaginatedResult)
    }
    useEffect(() => {
        const paginatedFuncResult = paginate(examQuestions, 4, currentPage)
        setPaginatedResults(paginatedFuncResult)
    }, [])

    useEffect(() => {

    }, [paginatedResults])
    return (
        <DashboardWrapper>
            <StyledTopWrapper>
                <StyledContainer>
                    <StyledContent>
                        <Breadcrumb
                            crumbs={['examination', 'English Language']}
                        />
                        <div className="top">
                            <h1 className="subject-title">English Language</h1>
                        </div>
                        <div className="bottom">
                            <p className='exam-text'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Turpis in eu mi bibendum neque egestas congue quisque egestas. In fermentum posuere urna nec tincidunt praesent semper feugiat. Augue mauris augue neque gravida in. Quam viverra orci sagittis eu volutpat odio facilisis mauris.</p>
                        </div>
                    </StyledContent>
                </StyledContainer>
            </StyledTopWrapper>
            <StyledNextPageDiv>
                <StyledNextPageDivContainer>
                    <div className="score-icon-div">
                        <div className="check-icon-container">
                            <MdHelpOutline />
                        </div>
                        <span>15 Questions</span>
                    </div>
                    <div className="class-icon-div">
                        <div className="check-icon-container">
                            <MdTimer />
                        </div>
                        <span>30 mins</span>
                    </div>
                    <div className="class-icon-div">
                        <div className="check-icon-container">
                            <MdAssessment />
                        </div>
                        <span>JSS 1</span>
                    </div>
                    <div className="next-page-btn-div">
                        <Button onClick={handleNextPage} variant="secondary">
                            NEXT PAGE
                        </Button>
                    </div>
                </StyledNextPageDivContainer>
            </StyledNextPageDiv>
            <StyledMainContentWrapper>
                <StyledContainer>
                    <QuestionsStepper questions={paginatedResults} />
                </StyledContainer>
            </StyledMainContentWrapper>

        </DashboardWrapper >
    )
}

export default ExamQuestions
